import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './registrationAddress.module.scss';

// MAIN COMPONENT
export default function RegistrationAddress({
  registration_address1,
  registration_city,
  registration_state,
  registration_zip_code,
  registration_county
}) {
  const showAddress = useMemo(() => {
    return [
      registration_address1,
      registration_city,
      registration_state,
      registration_zip_code,
      registration_county
    ].some(a => !!(a || '').trim());
  }, [registration_address1, registration_city, registration_state, registration_zip_code, registration_county]);

  return showAddress ? (
    <Form.Row className={styles.row}>
      <Form.Col cols={{ xs: 24 }} className={styles.label}>
        <Form.Label className="pt-0">Registration Address</Form.Label>
      </Form.Col>
      <Form.Col
        className={clsx(
          styles.address,
          'd-flex flex-column justify-content-center ps-3 ps-lg-4 pb-0 pb-lg-3 ms-1 large'
        )}
      >
        <div>{registration_address1}</div>
        <div>
          {registration_city}
          {registration_city ? ',' : ''} {registration_state} {registration_zip_code}
        </div>
        <div>{registration_county}</div>
      </Form.Col>
    </Form.Row>
  ) : null;
}
